// extracted by mini-css-extract-plugin
export default {"description":"segmented-control_description__qp8GC"};